"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("@package/utils");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var validate = function validate(values) {
  var errors = {};

  if (!values['email']) {
    errors['email'] = 'Обязательное поле';
  } else if (!_utils.validation.email(values['email'])) {
    errors['email'] = 'Неверный формат';
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: 'options-email-change',
  enableReinitialize: true,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;